const service = 'service-intercom';
export const getConversation = (api, payload) => api.rpc(service, '1/latest/get_conversation', payload);
export const getHash = (api, payload) => api.rpc(service, '1/2017-11-23/get_hash', payload);
